import React from "react";

import "./CloseButton.css";
import { Icon } from "../../Icon/Icon";

export const CloseButton = () => {
  return (
    <div className="CloseButton">
      <div className="CloseButton__border">
        <Icon name="iconClose" width={20} height={20} />
      </div>
    </div>
  );
};
